import React, { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import api from "../../../api";
import EmailVerified from "./EmailVerified";
import { Helmet } from "react-helmet-async";

function VerifyEmail() {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState("loading");

  useEffect(() => {
    const token = searchParams.get("token");

    if (!token) {
      setStatus("error");
      return;
    }

    const verifyEmail = async () => {
      try {
        await api.get("/auth/verify-email", {
          params: { token },
        });

        setStatus("success");
      } catch (err) {
        console.error(err);
        setStatus("error");
      }
    };

    verifyEmail();
  }, [searchParams]);

  if (status === "loading") {
    return (
      <>
      <Helmet>
      <title>Vérification | LMFP Photography</title>
      <meta name="robots" content="noindex, nofollow" />
      </Helmet>

      <div className="flex min-h-screen items-center justify-center bg-gray-900 text-white">
        <p className="text-gray-400">Vérification en cours...</p>
      </div>
      </>
    );
  }

  if (status === "error") {
    return (
      <>
       <Helmet>
      <title>Lien invalide | LMFP Photography</title>
      <meta name="robots" content="noindex, nofollow" />
      </Helmet>

      <div className="flex min-h-screen items-center justify-center bg-gray-900 px-4 text-white">
        <div className="text-center">
          <h1 className="mb-4 text-2xl font-bold">Lien invalide ou expiré</h1>

          <Link to="/login" className="text-orange-400 hover:underline">
            Retour à la connexion
          </Link>
        </div>
      </div>
      </>
    );
  }

  return <EmailVerified />;
}

export default VerifyEmail;